export enum DocumentMimeType {
  PDF = "application/pdf",
  EXCEL = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  EXCEL_LEGACY = "application/vnd.ms-excel",
  EXCEL_LEGACY_2003_TEMPLATE = "application/vnd.ms-excel.template.macroEnabled.12",
  EXCEL_LEGACY_2003_BINARY = "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
  EXCEL_LEGACY_2003_MACROENABLED = "application/vnd.ms-excel.sheet.macroenabled.12",
  CSV = "text/csv",
  PLAIN_TEXT = "text/plain",
  WORD = "application/msword",
  WORD_DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  JPEG = "image/jpeg",
  PNG = "image/png",
  GIF = "image/gif",
  TIFF = "image/tiff",
  BMP = "image/bmp",
  EDI = "application/edi-x12",
}
